import { lazy } from 'react';
import { LazyPanelBoundary, Sidebar } from '@/features/sidebar';
import { addFundsRequest, ADD_FUNDS_SIDEBAR_ID } from './add-funds-request';

const LazyAddFundsPanel = lazy(() => import('./add-funds-panel').then((module) => ({ default: module.AddFundsPanel })));

export function AddFundsSidebar() {
  const request = addFundsRequest.useRequestState();

  return (
    <Sidebar id={ADD_FUNDS_SIDEBAR_ID} onToggle={addFundsRequest.handleToggle}>
      <LazyPanelBoundary resetKey={request?.key} onLoadError={() => addFundsRequest.dismiss()}>
        {request == null ? null : (
          <LazyAddFundsPanel
            key={request.key}
            data={request.data}
            onConfirm={addFundsRequest.confirm}
            onClose={addFundsRequest.dismiss}
            onBusyChange={addFundsRequest.setBusy}
          />
        )}
      </LazyPanelBoundary>
    </Sidebar>
  );
}
